import React from "react";
import { getDateFromTime } from "../../../store/utility";
import QuillViewer from "../QuillEditor/QuillViewer";
import SimpleRating from "../Rating/SimpleRating";

const ReviewCard = (props)=>{
    let review = props.review;
    if(!review){
        return null;
    }
    return (
        <div className="mt-3">
            <label><b>Raj Mandal</b></label>
            <div className="d-flex flex-wrap">
               {review.rating&&( <div className="pr-2">
                    <SimpleRating
                            rating={review.rating}
                            key={Math.random()*10000}
                            readOnly={"readOnly"}
                        // onPostRating={()=>this.props.onPostReview(order.receipt,order.rating,null)}
                        />
                </div>)}
                    
                   {review.reviewHeadline&&( <label > <b>{review.reviewHeadline} </b></label>)}
            </div>
            <div style={{fontSize:"12.5px", color:"grey"}}>
                <label>{`Reviewed in ${review.country} on ${getDateFromTime(review.timestamp)}`}</label>
                <div className="d-flex">
                    {
                        review.attributes&&review.attributes.map(attribute=>(
                            <label className="mr-2">{attribute}</label>
                        ))
                    }
                   
                </div>
            </div>
            <div>
                <p align="justfy">
                   <QuillViewer value={review.review.trim()} />
                   
                </p>
            </div>
        </div>
    )
}

export default ReviewCard;